function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2249",
    xmlns: "http://www.w3.org/2000/svg",
    width: 808.97,
    height: 465.494,
    viewBox: "0 0 808.97 465.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "95m7a1k7ha"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 631",
    style: {
      fill: "none"
    },
    d: "M0 0h808.97v465.494H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 598",
    transform: "rotate(-76.83 304.334 -145.251)",
    style: {
      fill: "#eb6626"
    },
    d: "M0 0h157.528v157.528H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2248"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2247",
    style: {
      clipPath: "url(#95m7a1k7ha)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3539",
    d: "M511.087 67.564a3.155 3.155 0 1 1-2.281-4.04 3.287 3.287 0 0 1 2.281 4.04",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3540",
    d: "M466.936 57.21a3.155 3.155 0 1 1-2.281-4.04 3.287 3.287 0 0 1 2.281 4.04",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3541",
    d: "m464.16 55.279 3.49-14.879c3.109-13.258 15.529-21.683 27.741-18.819s19.591 15.933 16.483 29.189l-3.49 14.882",
    style: {
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      stroke: "#eb6626",
      strokeWidth: "4.24px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3542",
    d: "m456.634 220.2-158.115 21.858-14.6-161.2 143.045-19.777z",
    style: {
      fill: "#b0bc34"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3543",
    d: "M390.551 81.95a4.052 4.052 0 1 1-4.569-3.459 4.053 4.053 0 0 1 4.569 3.459",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3544",
    d: "M332.655 89.952a4.052 4.052 0 1 1-4.569-3.459 4.053 4.053 0 0 1 4.569 3.459",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3545",
    d: "m328.442 89.041-2.489-17.978a29.271 29.271 0 0 1 57.989-8.014l2.484 17.977",
    style: {
      stroke: "#b0bc34",
      strokeWidth: "5.244px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3546",
    d: "m458.222 145.815-1.33-18.421a19.99 19.99 0 0 0-39.948 1.468l.7 22.793",
    style: {
      stroke: "#0099d6",
      strokeWidth: "4.52px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3547",
    d: "m462.853 340.155 22.7-30.794 28.4 23.711.005.752-51.3 7.568z",
    style: {
      fill: "#66c2e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3548",
    d: "m485.556 309.361-22.7 30.792 30.77-198.7 3.845.185z",
    style: {
      fill: "#0073a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3549",
    d: "m497.469 141.645 15.227.732 1.259 190.7-28.4-23.71z",
    style: {
      fill: "#66c2e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3550",
    d: "M493.624 141.461 462.662 341.4l-125.523-14.816 29.077-187.878z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3551",
    d: "M400.9 148.226a3.157 3.157 0 1 0 3.307-3h-.007a3.157 3.157 0 0 0-3.3 3",
    style: {
      fill: "#3d2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3552",
    d: "M441.819 149.446a3.157 3.157 0 1 0 3.307-3h-.007a3.157 3.157 0 0 0-3.3 3",
    style: {
      fill: "#3d2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3553",
    d: "m445.065 148.981 1.912-18.369a19.99 19.99 0 0 0-39.589-5.542l-3.3 22.564",
    style: {
      stroke: "#0099d6",
      strokeWidth: "4.52px",
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3554",
    d: "M372.728 445.468a20.026 20.026 0 1 1-20.028-20.026 20.026 20.026 0 0 1 20.026 20.026",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3555",
    d: "m333.608 421.585 14.167 30.053a5.363 5.363 0 0 0 8.983.588l16.516-30.641z",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3556",
    d: "M356.53 446.1a3.827 3.827 0 1 1-3.827-3.827 3.826 3.826 0 0 1 3.827 3.827",
    style: {
      fill: "#e7d3b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3557",
    d: "M506.8 445.468a20.026 20.026 0 1 1-20.026-20.026 20.026 20.026 0 0 1 20.026 20.026",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3558",
    d: "m467.678 421.585 14.168 30.053a5.362 5.362 0 0 0 8.982.588l16.517-30.641z",
    style: {
      fill: "#3b2e87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3559",
    d: "M490.6 446.1a3.827 3.827 0 1 1-3.827-3.827 3.826 3.826 0 0 1 3.827 3.827",
    style: {
      fill: "#e7d3b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3560",
    d: "m519.37 351.062-211.088-24.311L269.024 189h282.535z",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 140",
    transform: "translate(317.28 189.004)",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "m0 0 21.566 141.267"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 141",
    transform: "translate(364.785 189.004)",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "m0 0 11.112 144.536"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 142",
    transform: "translate(412.289 189.004)",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "m0 0 .657 147.804"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 143",
    transform: "translate(449.997 189.004)",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "M9.797 0 0 151.072"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 144",
    transform: "translate(487.047 189.004)",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "M20.251 0 0 154.34"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3561",
    d: "m617.149 124.645-19.529 3.871a51.037 51.037 0 0 0-40.035 39.624l-39.014 186.741 13.958 15a30.5 30.5 0 0 1-22.329 51.277H317.28",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 145",
    transform: "translate(283.918 234.964)",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "m0 0 257.755 6.907"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 146",
    transform: "translate(295.638 282.387)",
    style: {
      stroke: "#2e2365",
      strokeLinejoin: "round",
      strokeWidth: "7.53px",
      strokeLinecap: "round",
      fill: "none"
    },
    d: "m0 0 234.583 14.044"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3562",
    d: "M194.5 47.967a47.682 47.682 0 1 1-47.682 47.682A47.682 47.682 0 0 1 194.5 47.967",
    style: {
      fill: "#5d50a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3563",
    d: "M190.3 68.086a2.466 2.466 0 0 1-1.581.372c-.3-.482-.351-1.062-.683-1.555-.389.149-.766.266-1.119.433-.989.468-1.99.916-2.945 1.447a16.706 16.706 0 0 0-2.637 1.761c-.769.645-1.556 1.274-2.277 1.969a13.608 13.608 0 0 0-2.46 3.042c-.389.685-.865 1.32-1.247 2.008a28.997 28.997 0 0 0-2.246 5.057 15.692 15.692 0 0 0-.483 1.985c-.159.827-.3 1.66-.4 2.5-.083.692-.106 1.392-.146 2.089-.03.536-.05 1.073-.064 1.61a7.12 7.12 0 0 0 .015.8c.046.518.116 1.034.169 1.552a12.8 12.8 0 0 0 .847 3.434 26.148 26.148 0 0 0 1.87 3.753 16.744 16.744 0 0 0 1.795 2.281 23.678 23.678 0 0 0 3.709 3.262 17.884 17.884 0 0 0 3.413 2.032 21.231 21.231 0 0 0 3.6 1.277 22.627 22.627 0 0 0 3.154.671c.624.065 1.246.153 1.869.222a10.452 10.452 0 0 0 2.836-.147.777.777 0 0 0 .176-.086c.1-.505-.16-1.054.1-1.586a1.4 1.4 0 0 1 .248-.038 3.274 3.274 0 0 0 1.112-.154 2.559 2.559 0 0 1 .583-.086.363.363 0 0 1 .318.12l.252 1.169a.541.541 0 0 0 .516.062c.28-.059.562-.109.839-.179a58.703 58.703 0 0 0 1.659-.444 1.659 1.659 0 0 0 .34-.2c-.071-.255-.129-.5-.2-.732a1.092 1.092 0 0 1-.077-.776c.2-.081.43-.17.657-.266s.422-.186.612-.27c.1-.54.1-.54.3-.652a.734.734 0 0 1 .309.536c.213.814.409 1.632.613 2.448.039.156.078.313.12.468.124.447.053.609-.389.795a10.607 10.607 0 0 1-1.008.376c-.8.245-1.613.483-2.426.7-.431.116-.875.185-1.312.281a3.332 3.332 0 0 0-.333.111 14.412 14.412 0 0 0 .073 1.7 7.741 7.741 0 0 0 .115 1.608.519.519 0 0 0 .408.216c1.026.166 2.057.306 3.075.513.807.164 1.6.4 2.394.623 1.173.333 2.339.688 3.51 1.027.637.184 1.285.334 1.916.535a32.811 32.811 0 0 1 4 1.439 6.383 6.383 0 0 1 .658.363.3.3 0 0 1 .156.364.309.309 0 0 1-.294.2q-.912.009-1.826.01c-.519 0-1.037-.006-1.556-.008-.554 0-1.109-.006-1.663 0-.5 0-1 .042-1.5.02a22.491 22.491 0 0 0-2.305.143c-.642.036-1.288.007-1.931.031-.769.029-1.537.087-2.306.128-.357.019-.715.025-1.072.041a7.08 7.08 0 0 0-.483.035c-.624.068-1.249.132-1.872.211-.266.034-.526.108-.79.151-.247.04-.5.074-.745.091-.321.022-.646 0-.965.038q-3.184.344-6.368.7a6.959 6.959 0 0 0-1.216.214 8.594 8.594 0 0 1-1.01.148c-.37.061-.738.137-1.107.2-.176.031-.354.064-.532.079a12.6 12.6 0 0 0-2.21.437c-.431.115-.875.185-1.312.281-.209.046-.414.114-.624.157-.18.037-.319-.017-.354-.265a1.48 1.48 0 0 1 .248-.233c.447-.265.9-.517 1.355-.772.906-.51 1.811-1.024 2.72-1.527.941-.521 1.882-1.043 2.835-1.541.6-.314 1.227-.594 1.85-.87q2.361-1.045 4.732-2.069c.345-.15.71-.249 1.064-.377.166-.06.326-.137.483-.2a3.688 3.688 0 0 0-.029-1.1c-.005-.358.005-.718-.029-1.073a3.122 3.122 0 0 0-.182-1.084 4 4 0 0 0-.477.007 16.207 16.207 0 0 1-3.325.021 64.79 64.79 0 0 1-3.259-.362 20.24 20.24 0 0 1-3.295-.781c-.36-.111-.717-.233-1.076-.344a17.9 17.9 0 0 1-3.026-1.393c-.364-.193-.733-.38-1.086-.592-.476-.285-.938-.594-1.407-.89a24.851 24.851 0 0 1-2.146-1.619 12.2 12.2 0 0 1-1.335-1.246 27.1 27.1 0 0 0-.985-.992 1.1 1.1 0 0 1-.3-.435 1.432 1.432 0 0 0-.236-.419 15.227 15.227 0 0 1-1.846-3.148c-.254-.534-.455-1.094-.721-1.622a14.386 14.386 0 0 1-.85-2.317c-.072-.236-.084-.49-.143-.731-.127-.522-.266-1.041-.4-1.561a1.718 1.718 0 0 1-.043-.211c-.115-1.016-.237-2.032-.337-3.05a4.4 4.4 0 0 1 .026-.859q.178-1.821.378-3.637c.045-.409.12-.816.2-1.221.141-.758.277-1.518.447-2.27.118-.524.289-1.035.438-1.552a24.732 24.732 0 0 1 1.185-3.057 20.207 20.207 0 0 1 1.5-2.854 26.545 26.545 0 0 1 2.408-3.231 21.81 21.81 0 0 1 3.076-2.845c.6-.458 1.249-.844 1.888-1.242a30.076 30.076 0 0 1 1.81-1.058c.538-.284 1.1-.525 1.661-.764.693-.3 1.393-.574 2.093-.852a10.526 10.526 0 0 1 2.07-.561c.588-.1.754 0 1.007.554a15.654 15.654 0 0 1 .841 2.381.959.959 0 0 1-.039.712",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3564",
    d: "M213.517 85.8c.038.339.074.678.114 1.016a18.035 18.035 0 0 1 .113 3.382c-.055.786-.075 1.574-.187 2.356a18.693 18.693 0 0 1-1.084 3.989 19.3 19.3 0 0 1-2.243 4.1l-.518.754a15.152 15.152 0 0 1-2.546 2.76 21.718 21.718 0 0 1-4.452 2.9c-.127.066-.26.121-.393.174-.5.2-1 .4-1.5.595a12.279 12.279 0 0 1-2.07.571c-.772.159-1.552.282-2.332.4a14.824 14.824 0 0 1-1.93.129c-.88.013-1.755-.038-2.631-.08a19.306 19.306 0 0 1-5.531-1.023 42.514 42.514 0 0 1-3.144-1.264 17.746 17.746 0 0 1-2.75-1.575 33.869 33.869 0 0 1-2.365-1.778 12.538 12.538 0 0 1-2.815-3.371 17.391 17.391 0 0 1-1.722-3.873 14.7 14.7 0 0 1-.235-.883 77.67 77.67 0 0 1-.409-1.78 4.272 4.272 0 0 1-.084-.694c-.022-.447-.037-.9-.037-1.344 0-.788.021-1.576.02-2.364a16.467 16.467 0 0 1 .636-4.457 29.844 29.844 0 0 1 1.051-3.051 21.85 21.85 0 0 1 1.862-3.454c.4-.638.832-1.256 1.251-1.882a3.324 3.324 0 0 1 .227-.3 32.883 32.883 0 0 1 3.232-3.454 12.907 12.907 0 0 1 2.531-1.72c.684-.356 1.356-.739 2.059-1.052s1.436-.557 2.16-.819c.269-.1.551-.159.826-.239.052-.015.1-.045.151-.055a16.119 16.119 0 0 1 3.511-.461c.5.01 1-.006 1.5-.04a9.571 9.571 0 0 1 2.459.18c.828.157 1.656.314 2.478.5a18.035 18.035 0 0 1 3.05.865 19.085 19.085 0 0 1 5.293 3.049 12 12 0 0 1 .972.928 45.46 45.46 0 0 1 1.42 1.617 17.412 17.412 0 0 1 1.409 2.1 15.469 15.469 0 0 1 1.809 4.238c.023.086.058.17.088.254a9.99 9.99 0 0 1 .553 2.514c.049.554.121 1.106.183 1.659z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3565",
    d: "M193.207 105.432c-.094.052-.166.123-.239.123a.314.314 0 0 1-.23-.108 1.28 1.28 0 0 1-.174-.386c-.085-.311-.13-.633-.231-.937-.112-.338-.271-.661-.4-.992a6.825 6.825 0 0 1-.325-.85 2.615 2.615 0 0 1 .16-1.632 9.345 9.345 0 0 1 .43-.832.936.936 0 0 1 .3.073.227.227 0 0 1 .046.294c-.065.147-.149.286-.219.431a2.2 2.2 0 0 0-.033 2.063 7.152 7.152 0 0 1 .586 1.382c.117.431.213.868.334 1.371",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3566",
    d: "m193.791 82.893.21.173a.429.429 0 0 1-.208.392c-.247.206-.5.4-.738.619a5.629 5.629 0 0 0-1.55 2.467 4.514 4.514 0 0 0-.116.576c-.063.1-.164.159-.267.095a.385.385 0 0 1-.184-.239A1.46 1.46 0 0 1 191 86.4a8.952 8.952 0 0 1 .523-1.171 6.572 6.572 0 0 1 2.267-2.336",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3567",
    d: "M185.936 88.752c-.091.059-.157.132-.231.141a.324.324 0 0 1-.245-.068 1.191 1.191 0 0 1-.269-.389 3.933 3.933 0 0 1-.24-1.31c0-.356-.007-.714-.032-1.069a1.393 1.393 0 0 0-.364-1.04l.153-.236a.493.493 0 0 1 .534.377 2.789 2.789 0 0 1 .208 1.044c0 .3.006.606.03.908a3 3 0 0 0 .456 1.642",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3568",
    d: "m196.039 105.256.224-.26a2.942 2.942 0 0 1 .338.2 3.538 3.538 0 0 0 2 .657 1.12 1.12 0 0 1 .316.025.822.822 0 0 1 .217.181.365.365 0 0 1-.411.313 4.381 4.381 0 0 1-2.326-.71 1.364 1.364 0 0 1-.2-.172 1.957 1.957 0 0 1-.158-.234",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3569",
    d: "m198.316 71.213-.148.217a1.021 1.021 0 0 1-.219-.042c-.261-.114-.513-.253-.78-.35a2.832 2.832 0 0 0-1.1-.194 1.254 1.254 0 0 1-.228-.033c-.021-.068-.072-.143-.054-.193a.329.329 0 0 1 .16-.193 1.029 1.029 0 0 1 .419-.057 4.744 4.744 0 0 1 1.589.454.623.623 0 0 1 .361.391",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3570",
    d: "M198.432 94.932a2.108 2.108 0 0 1 .279-.246.34.34 0 0 1 .208-.027 1.873 1.873 0 0 1 1.279.81l-.177.247a.452.452 0 0 1-.137-.012.68.68 0 0 1-.18-.11 1.7 1.7 0 0 0-.987-.483c-.072-.008-.143-.086-.285-.179",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3571",
    d: "M180.5 122.806a8.559 8.559 0 0 1 .9-.339 33.8 33.8 0 0 1 2.144-.493c1.9-.367 3.836-.522 5.757-.75s3.852-.421 5.778-.629c.285-.031.57-.068.856-.088s.572-.02.857-.032c.143-.006.286-.014.429-.028.678-.067 1.355-.177 2.035-.2 1.185-.035 2.356-.223 3.536-.28.662-.032 1.322-.108 1.983-.12.948-.018 1.9-.1 2.842-.1.649 0 1.286-.089 1.929-.114.788-.031 1.573-.1 2.359-.155.391-.027.786.016 1.179.022s.787 0 1.18.011a1.7 1.7 0 0 1 .318.038.422.422 0 0 1 .324.259 2.554 2.554 0 0 1 .211.716c.022.372-.037.749-.045 1.125a.68.68 0 0 1-.486.641c-.115.048-.241.069-.361.106a12.361 12.361 0 0 1-1.565.372c-.723.124-1.439.28-2.159.419a5.88 5.88 0 0 1-.479.071c-.5.058-1 .121-1.5.165-.32.028-.643.026-.964.041-.161.008-.322.024-.483.036a6.769 6.769 0 0 1-1.394.061.865.865 0 0 0-.161.006c-.715.036-1.43.106-2.145.1-.774-.006-1.536.118-2.3.147-1.9.071-3.78.4-5.676.519-1.934.126-3.852.389-5.78.564-.518.047-1.034.115-1.552.166a11.647 11.647 0 0 1-1.875.136 2.66 2.66 0 0 0-.428.037c-.714.072-1.427.157-2.142.213a15.217 15.217 0 0 1-2.037.022 1.252 1.252 0 0 1-1.253-1.225 4.355 4.355 0 0 1 .168-1.445",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3572",
    d: "M198.426 115.059c.073-.025.147-.045.221-.064a.444.444 0 0 1-.168-.151c-.017-.115-.033-.234-.049-.353-.056.009-.111.02-.167.028-.8.111-1.6.2-2.4.293a1.546 1.546 0 0 1-.023.555l2.266-.259a1.511 1.511 0 0 0 .32-.049",
    style: {
      fill: "#e5a579"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3573",
    d: "M192.094 75.41a1.169 1.169 0 0 1 .018-.167 2.019 2.019 0 0 1 .62-.651c.373-.308.756-.606 1.125-.918a4.448 4.448 0 0 0 .541-.522.64.64 0 0 0 .007-.9.586.586 0 0 0-.059-.053 2.043 2.043 0 0 0-.344-.255 2.9 2.9 0 0 0-1.514-.262 5.956 5.956 0 0 0-2.1.927 1.716 1.716 0 0 0-.384.372 3.221 3.221 0 0 0-.517 2.41c.055.37.172.731.262 1.1.03.122.061.244.1.363a.5.5 0 0 0 .592.386h.023a1.409 1.409 0 0 0 .406-.126 2.717 2.717 0 0 0 .455-.286 1.668 1.668 0 0 0 .769-1.408",
    style: {
      fill: "#dcc986"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3574",
    d: "M200.576 71.033c-.056.263-.09.53-.141.794-.064.334-.127.668-.207 1a.832.832 0 0 1-.47.56 2.033 2.033 0 0 1-1.035.25 10.008 10.008 0 0 0-1.822.119.817.817 0 0 0-.795.838v.062a2.125 2.125 0 0 0 .176.89 4.976 4.976 0 0 0 .594 1.02 1.629 1.629 0 0 1 .388.653 2.358 2.358 0 0 1-.222.225 7.109 7.109 0 0 0-1.328 1.4 2.564 2.564 0 0 0-.6 1.232 2.65 2.65 0 0 0 .449.864 1.2 1.2 0 0 1 .226.92c-.14.279-.374.526-.361.866.276.286.407.336.7.181a6.865 6.865 0 0 0 1.009-.612 21.416 21.416 0 0 1 1.947-1.342 6.369 6.369 0 0 1 1.537-.633.966.966 0 0 1 .974.127c.056.149.142.345.2.549a1.255 1.255 0 0 0 .542.712.737.737 0 0 0 .811.072c.234-.131.466-.267.7-.4a6.667 6.667 0 0 1 .7-.393.951.951 0 0 1 1.013.084c.05.127.118.291.18.457.043.117.074.239.117.356a1.213 1.213 0 0 0 1.485.734c.257-.077.517-.146.778-.206a2.731 2.731 0 0 1 .478-.072 1.229 1.229 0 0 1 1.276.79c.037.082.066.166.1.25a1.7 1.7 0 0 0 1.079 1.052c.339.116.672.253 1.009.374.134.048.274.079.392.112a1.051 1.051 0 0 0 .749-.865c.025-.109.041-.219.057-.329a10.036 10.036 0 0 0-.5-2.1c-.03-.084-.066-.167-.088-.254a15.513 15.513 0 0 0-1.809-4.238 17.412 17.412 0 0 0-1.409-2.1 45.46 45.46 0 0 0-1.42-1.617 12.011 12.011 0 0 0-.973-.928 18.95 18.95 0 0 0-5.223-3.02c-.092.047-.184.1-.274.155a2.13 2.13 0 0 0-.993 1.411",
    style: {
      fill: "#dcc986"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3575",
    d: "M188.747 94.333a2.934 2.934 0 0 0-1.064-.354c-.424-.066-.843-.161-1.265-.237a1.541 1.541 0 0 1-.7-.375 3.944 3.944 0 0 1-.979-1.27 5.968 5.968 0 0 0-1.627-1.906c-.236-.191-.455-.4-.678-.611a4.933 4.933 0 0 0-1.376-.926 2.76 2.76 0 0 0-2.24-.113 1.547 1.547 0 0 0-.461.265 13.28 13.28 0 0 1-.576.484 3.3 3.3 0 0 0-.736.851 1.694 1.694 0 0 0-.127 1.785c.074.143.139.291.208.437a7.044 7.044 0 0 1 .548 1.736c.144.756.289 1.511.49 2.254a9.994 9.994 0 0 0 1.113 2.609 24.025 24.025 0 0 0 2.07 2.676c.364.443.741.875 1.063 1.35a4.484 4.484 0 0 0 2.07 1.732c.216.086.438.161.653.25.43.178.86.356 1.285.546a9.166 9.166 0 0 0 2.092.677.455.455 0 0 0 .542-.65 1.6 1.6 0 0 0-.225-.426 8.093 8.093 0 0 0-.557-.655 48.05 48.05 0 0 0-1.193-1.237 2.288 2.288 0 0 1-.626-1.094 1.468 1.468 0 0 1 .6-.994 6.008 6.008 0 0 0 .615-.6 1.5 1.5 0 0 0 .428-1.119 2.957 2.957 0 0 1 .53-1.826 5.753 5.753 0 0 0 .305-.506 3.983 3.983 0 0 0 .5-1.3 1.345 1.345 0 0 0-.682-1.453",
    style: {
      fill: "#dcc986"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3576",
    d: "M209.416 88.182a3.513 3.513 0 0 0-.417-.1c-.139-.034-.28-.062-.417-.1a.549.549 0 0 1-.416-.5 1.946 1.946 0 0 1 .031-.693c.07-.278.128-.559.178-.841a1.882 1.882 0 0 0-.094-.952 1.765 1.765 0 0 0-.978-1.019 9.223 9.223 0 0 0-.943-.391 3.161 3.161 0 0 1-1.024-.576 6.038 6.038 0 0 0-.657-.465 1.049 1.049 0 0 0-1.076-.023c-.113.053-.222.117-.333.175-.427.224-.427.224-.636.7l-.188.064a1.881 1.881 0 0 1-1.781-.264 2.8 2.8 0 0 0-.368-.221 1.772 1.772 0 0 0-1.553-.1c-.131.056-.264.111-.394.171a5.845 5.845 0 0 0-1.113.748 1.572 1.572 0 0 1-.781.331c-.142.018-.286.032-.427.058a3.444 3.444 0 0 0-2.008 1.057 7.162 7.162 0 0 0-1.554 2.8 2.462 2.462 0 0 0-.091 1.168 2.092 2.092 0 0 0 1.368 1.663 3.831 3.831 0 0 0 1.369.245c.787 0 1.574-.023 2.361-.036a2.438 2.438 0 0 1 1.649.537c.166.137.333.274.507.4a1.82 1.82 0 0 1 .7 1.049c.1.38.214.757.321 1.136.175.62.359 1.237.521 1.86a1.918 1.918 0 0 1 .054.852 5.213 5.213 0 0 1-.115.633 7.878 7.878 0 0 0-.216 3.51c.078.616.28.808.9.858a1.725 1.725 0 0 0 .424-.031c.141-.023.276-.079.417-.1a2.1 2.1 0 0 0 .793-.318 5.153 5.153 0 0 0 1.071-.893 11.558 11.558 0 0 0 1.272-1.8 5.911 5.911 0 0 0 .8-2.431 5.129 5.129 0 0 1 .559-2.008q.557-.981 1.161-1.935a18.907 18.907 0 0 0 1.191-1.979 4.1 4.1 0 0 0 .43-1.379.747.747 0 0 0-.5-.86",
    style: {
      fill: "#dcc986"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3577",
    d: "M174.591 85.657c.1.417.223.83.344 1.242a2.966 2.966 0 0 0 .663 1.157 1.6 1.6 0 0 0 .68.416.721.721 0 0 0 .666-.1 1.035 1.035 0 0 0 .434-.6 1.917 1.917 0 0 0 .049-.957 9.172 9.172 0 0 0-.224-.94 14.315 14.315 0 0 1-.447-1.824 1.253 1.253 0 0 1 .177-1.027.386.386 0 0 1 .481-.172 1.836 1.836 0 0 1 .418.661 4.4 4.4 0 0 0 .373.713.925.925 0 0 0 1.269.323.911.911 0 0 0 .25-.217 5.236 5.236 0 0 0 .487-.642 7.712 7.712 0 0 0 .7-1.512 2.547 2.547 0 0 1 1.373-1.367 1.187 1.187 0 0 1 .679-.107c.337.046.676.084 1.015.108a2.332 2.332 0 0 0 1.572-.442 1.322 1.322 0 0 0 .58-1.256c-.023-.25-.075-.5-.1-.747-.037-.4.1-.562.495-.614.213-.028.43-.03.643-.063a.842.842 0 0 0 .661-.5 1.49 1.49 0 0 0-.151-1.624.87.87 0 0 0-.79-.374 1.86 1.86 0 0 0-.73.165c-.273.135-.552.26-.83.383a1.043 1.043 0 0 1-.222.039.735.735 0 0 1 .086-.184q.269-.264.546-.517c.438-.4.886-.785 1.315-1.192a4.826 4.826 0 0 0 .564-.647.791.791 0 0 0 .1-.865 1.207 1.207 0 0 0-1.063-.715 2.76 2.76 0 0 0-1.453.324c-.215.124-.451.21-.72.334A4.984 4.984 0 0 1 184 72c-.191-.161-.36-.349-.545-.519a1.56 1.56 0 0 0-.753-.41 12.68 12.68 0 0 0-1.651 1.214 32.994 32.994 0 0 0-3.233 3.454 3.107 3.107 0 0 0-.227.3c-.42.626-.851 1.244-1.251 1.882a21.689 21.689 0 0 0-1.862 3.454c-.29.724-.558 1.456-.795 2.2l.038.064a7.239 7.239 0 0 1 .872 2.021",
    style: {
      fill: "#dcc986"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3578",
    d: "M242.179 242.491a34.133 34.133 0 1 1-34.135-34.135 34.133 34.133 0 0 1 34.135 34.135z",
    style: {
      fill: "#2e2365"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3579",
    d: "M192.925 232.795a1.025 1.025 0 0 1 .654-.135c.641.023 1.282.057 1.923.072.92.022 1.841.029 2.762.047.707.014 1.415.032 2.122.058a.775.775 0 0 1 .56.165c.028.091.069.232.116.37a1.388 1.388 0 0 0 1.246 1.036 1.456 1.456 0 0 0 1.517-.7.82.82 0 0 0 .073-.129.575.575 0 0 1 .725-.351 14.4 14.4 0 0 0 1.968.138c1.841.066 3.682.143 5.524.19q2.245.057 4.485.219c1.428.105 2.854.229 4.281.339.935.072 1.872.125 2.806.2 1.443.116 2.885.235 4.326.371a2.51 2.51 0 0 1 1.044.23.589.589 0 0 1 .143.467c-.024.526-.036 1.052-.08 1.577-.055.639-.135 1.276-.208 1.914q-.218 1.889-.442 3.776c-.157 1.324-.313 2.648-.476 3.971-.1.784-.2 1.567-.31 2.35a.654.654 0 0 1-.243.516c-.273-.018-.584-.029-.893-.06-.851-.084-1.7-.181-2.552-.264-1.245-.121-2.489-.243-3.735-.349a93.116 93.116 0 0 1-5.2-.61 426.712 426.712 0 0 0-6.653-.907c-2.873-.365-5.757-.627-8.645-.856-1.23-.1-2.456-.247-3.682-.385-.9-.1-1.8-.22-2.694-.341a5.921 5.921 0 0 1-.722-.159 2.062 2.062 0 0 1-.364-.149.563.563 0 0 1-.333-.51c-.008-.18 0-.362 0-.543.041-1.365.074-2.73.213-4.091.077-.752.072-1.512.121-2.267.063-.969.127-1.938.22-2.9.062-.638.171-1.272.269-1.907a2.365 2.365 0 0 1 .134-.393",
    style: {
      fill: "#f6d8ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3580",
    d: "M202.295 234.414a.221.221 0 0 1 .168.165 1.368 1.368 0 0 1-.04.569c-.053.439-.112.877-.174 1.314a1.176 1.176 0 0 1-.088.33.28.28 0 0 1-.168.157.616.616 0 0 1-.242-.063.521.521 0 0 1-.028-.129c.086-.649.17-1.3.263-1.946a.653.653 0 0 1 .106-.377.225.225 0 0 1 .2-.02",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3581",
    d: "m229.528 243.7-1.208.494c-.653.267-1.3.544-1.961.8-.689.268-1.39.508-2.08.774-.628.243-1.248.5-1.871.759-.441.18-.882.36-1.321.545q-.817.343-1.632.693c-.03.013-.059.029-.09.041-.631.237-1.264.466-1.892.713-.6.234-1.185.485-1.777.729-.046.019-.089.044-.135.061-.678.251-1.358.5-2.035.752-.276.1-.546.225-.821.333-.168.066-.341.123-.511.182a5.911 5.911 0 0 0-1.2.46 1.55 1.55 0 0 1-.324.118 7.664 7.664 0 0 0-1.383.522 2.655 2.655 0 0 1-.466.163 6.745 6.745 0 0 0-1.29.49 1.17 1.17 0 0 1-.326.114 20.18 20.18 0 0 0-2.128.787 8.839 8.839 0 0 0-.888.428 2.012 2.012 0 0 1-.916.266c-.086-.077-.184-.161-.279-.25-.168-.157-.325-.328-.5-.472a.964.964 0 0 0-1.33.113 3.134 3.134 0 0 0-.7 1.4c-.021.1-.019.2-.046.292a.549.549 0 0 1-.384.416 18.018 18.018 0 0 1-2.185.612 1.386 1.386 0 0 0-.283.081c-.338.126-.67.272-1.013.383q-1.436.463-2.878.9c-.282.085-.578.118-.865.189a.6.6 0 0 1-.695-.341.485.485 0 0 1-.043-.089c-.2-.506-.387-1.013-.588-1.517-.1-.244-.224-.477-.315-.722-.275-.74-.554-1.479-.805-2.226-.278-.828-.52-1.667-.792-2.5a9.639 9.639 0 0 0-.621-1.716 1.777 1.777 0 0 1-.112-.327q-.917-2.923-1.83-5.849a.9.9 0 0 1 0-.8c.19-.1.4-.233.624-.328.485-.2.979-.383 1.466-.581.259-.1.511-.226.764-.344.595-.279 1.188-.562 1.783-.84.089-.042.185-.069.276-.107.529-.223 1.057-.45 1.587-.671.167-.069.34-.123.509-.187.276-.1.556-.2.825-.324a.571.571 0 0 1 .566.043 1.711 1.711 0 0 0 1.591 1.074.906.906 0 0 0 .65-.726c.058-.289.1-.581.147-.873.02-.129.023-.26.037-.424a2.58 2.58 0 0 1 .332-.178c.248-.089.5-.154.753-.242.216-.076.427-.17.639-.258a.9.9 0 0 1 .18-.078 23.169 23.169 0 0 0 2.339-.755 5.316 5.316 0 0 0 1.478-.547.486.486 0 0 1 .092-.035c1.221-.394 2.453-.755 3.642-1.245.137-.056.283-.088.423-.137.978-.342 1.968-.654 2.928-1.041.489-.2 1-.339 1.473-.561.766-.36 1.585-.551 2.374-.833.185-.066.364-.151.546-.226.152-.062.3-.13.458-.181.5-.164 1.006-.316 1.506-.484.233-.078.456-.185.684-.277.136-.058.274-.111.415-.156a19.264 19.264 0 0 1 2.044-.565 12.721 12.721 0 0 0 1.466-.438 7.744 7.744 0 0 1 1.2-.3 6.8 6.8 0 0 0 .95-.267c.462-.13.607-.074.862.33a2.412 2.412 0 0 1 .214.389c.223.566.431 1.137.654 1.7.265.672.542 1.34.811 2.01q.092.229.167.465c.239.754.474 1.509.714 2.262a6 6 0 0 0 .469 1.246 1.825 1.825 0 0 1 .133.371c.528 1.682 1.061 3.362 1.577 5.048a8.94 8.94 0 0 1 .224 1.11 1.351 1.351 0 0 1-.051.358",
    style: {
      fill: "#fef5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3582",
    d: "M225.584 236.128a5.438 5.438 0 0 1 .069 3.4 5.085 5.085 0 0 1-1.247 2.1 5.144 5.144 0 0 1-1.883 1.233 4.191 4.191 0 0 1-.91.211 5.8 5.8 0 0 1-2.591-.105 5.155 5.155 0 0 1-2.884-2.036c-.212-.31-.372-.656-.553-.987a.425.425 0 0 1-.051-.138 10.589 10.589 0 0 1-.274-1.9 6.4 6.4 0 0 1 .571-2.684 4.334 4.334 0 0 1 1.516-1.72 5.512 5.512 0 0 1 2.486-.876 8.724 8.724 0 0 1 1.427-.066 4.4 4.4 0 0 1 2.834 1.117 4.788 4.788 0 0 1 1.327 1.935c.06.168.109.343.163.516m-4.422 6.454.016.005h-.018a3.412 3.412 0 0 0-.936-.321.675.675 0 0 0-.452.293 3.088 3.088 0 0 0 1.389.022zm-3.528-8.63a.819.819 0 0 0-.179.079 3.646 3.646 0 0 0-1.225 1.561c-.009.022.016.059.031.106.182.107.366.006.548 0 .115-.3.2-.582.331-.847.147-.309.326-.6.49-.9l.018-.034zm-.389 2.226c-.019.124-.037.2-.043.286a7.144 7.144 0 0 0 .173 1.861 1.1 1.1 0 0 0 .272.66 12.264 12.264 0 0 0 2.6-1.093 1.027 1.027 0 0 0-.038-.226q-.395-.982-.8-1.962a1.128 1.128 0 0 0-.114-.168zm.669 3.329a4.242 4.242 0 0 0 2.246 2.141 5.421 5.421 0 0 0 .567-.328c.194-.142.477-.156.613-.447a12.018 12.018 0 0 0-.9-2.375 4.866 4.866 0 0 0-1.267.479c-.423.155-.841.351-1.26.529zm3.081-1.249c.094.3.171.571.263.834.076.217.176.425.254.641.09.248.164.5.252.749a2.086 2.086 0 0 0 .128.249c.5-.241 1.035-.309 1.5-.547.025-.077.05-.138.064-.2a8.411 8.411 0 0 0 .136-2.016 1.363 1.363 0 0 0-.26-.776.678.678 0 0 0-.162.02q-.952.408-1.9.82a.78.78 0 0 0-.164.109 1.226 1.226 0 0 0-.112.116zm2.105-1.592a2.77 2.77 0 0 0-.752-1.305 3.686 3.686 0 0 0-1.224-.9c-.4.3-.861.513-1.275.823.021.1.048.2.079.3.218.584.437 1.169.665 1.75a.462.462 0 0 0 .271.323c.368-.154.733-.3 1.092-.459s.739-.343 1.144-.534zm1.789-.85a1.277 1.277 0 0 0-.319-.785 4.469 4.469 0 0 0-1.085-1.2 2.79 2.79 0 0 0-1.112-.522c-.2.2-.4.393-.592.594a1.369 1.369 0 0 0-.13.2 1.813 1.813 0 0 0 .2.182 4.859 4.859 0 0 1 1.666 1.908 1.71 1.71 0 0 0 .129.186 2.868 2.868 0 0 0 1.243-.564zm-.064 4.328a4.466 4.466 0 0 0 .234-3.778 12.436 12.436 0 0 0-1.183.579c.038.15.061.279.1.4a2.785 2.785 0 0 1 .131.92 9.114 9.114 0 0 1-.129 1.666 1.088 1.088 0 0 0 .011.235zm-5.759 2.268a1.18 1.18 0 0 0 .523-.427 8.529 8.529 0 0 1-1.292-1.011c-.38-.385-.635-.863-.976-1.273l-1.009.393a4.106 4.106 0 0 0 2.754 2.316zm-3-6.2a5.078 5.078 0 0 0 0 3.393 3.827 3.827 0 0 0 1-.357c-.078-.388-.139-.758-.228-1.12a6.014 6.014 0 0 1-.155-1.61 1.838 1.838 0 0 0-.038-.286c-.124-.007-.221-.015-.318-.019a2.4 2.4 0 0 0-.264-.007zm2.587-2.581a3.429 3.429 0 0 0-1.176 1.9 12.041 12.041 0 0 0 1.455-.434 1.1 1.1 0 0 0 .21-.116 7.594 7.594 0 0 0-.492-1.355zm.584-.064a2.922 2.922 0 0 0 .478 1.178c.291-.173.556-.327.817-.49.045-.028.067-.092.12-.169a6.684 6.684 0 0 0-1.418-.522zm2.585-.414a4.009 4.009 0 0 0-1.861.031 5.667 5.667 0 0 0 1.265.557zm.539 8.877c.386-.212.456-.4.692-.9.034-.071.077-.148-.029-.235a3.362 3.362 0 0 0-.966.351zm1.365-1.24c-.082.182-.165.36-.242.54s-.139.346-.229.571a2.406 2.406 0 0 0 .666-.507c.152-.147.295-.3.432-.467a1.168 1.168 0 0 0 .117-.238 1.146 1.146 0 0 0-.746.1zm-2.922 1.079a2.419 2.419 0 0 0 1.041.312 1.526 1.526 0 0 0-.328-.746c-.206.206-.509.216-.715.429z",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3583",
    d: "M199.745 239.277a.85.85 0 0 1 .516-.358c.789-.284 1.591-.536 2.364-.859.716-.3 1.468-.492 2.181-.788s1.468-.492 2.181-.786c.763-.314 1.564-.517 2.322-.832a18.673 18.673 0 0 1 1.91-.665c.078-.023.158-.036.213-.048a.586.586 0 0 1 .421.415c.044.107.07.22.11.328.282.773.53 1.561.859 2.313.319.728.52 1.491.788 2.233.1.262.2.519.306.779.042.107.085.214.12.324q.69 2.166 1.378 4.333l.03.094c.134.456.082.567-.346.771-.563.268-1.125.54-1.688.81-.059.028-.121.051-.182.077-.942.4-1.92.688-2.88 1.032-.7.249-1.388.506-2.068.8-.452.2-.934.32-1.4.484-.232.082-.455.189-.688.267q-.984.328-1.973.641a.443.443 0 0 1-.518-.2 4.225 4.225 0 0 1-.393-.681q-.415-.946-.8-1.91c-.258-.658-.5-1.322-.731-1.991-.266-.78-.507-1.567-.759-2.352a1.894 1.894 0 0 0-.079-.234 30.163 30.163 0 0 1-1.148-3.415 1.041 1.041 0 0 1-.053-.24c0-.111.006-.226.007-.342m4.352 10.858a2.078 2.078 0 0 0 .235-.046c.887-.3 1.8-.536 2.657-.917.6-.265 1.228-.467 1.843-.7.538-.2 1.073-.413 1.616-.6s1.1-.36 1.643-.539a1.353 1.353 0 0 0 .138-.053c.559-.238 1.119-.472 1.675-.718a6.658 6.658 0 0 0 1.131-.616 10.128 10.128 0 0 0-.383-1.187 11.821 11.821 0 0 1-.456-1.25c-.17-.516-.333-1.034-.5-1.55a2.913 2.913 0 0 0-.152-.319c-.163.047-.307.077-.443.129-.384.145-.761.31-1.149.444-.607.21-1.22.4-1.83.6a2.133 2.133 0 0 0-.373.128 8.267 8.267 0 0 1-1.288.5 1.456 1.456 0 0 0-.231.086 6.414 6.414 0 0 1-1.194.463c-.124.044-.251.079-.373.129-.609.246-1.209.516-1.826.74-.757.275-1.528.508-2.27.825a2.033 2.033 0 0 0-.252.156c.06.193.1.369.171.536s.164.323.227.491c.267.707.519 1.42.79 2.126.123.321.273.633.42.945a1.08 1.08 0 0 0 .177.197zm-3.1-8.307a1.342 1.342 0 0 0 .132-.042c.666-.281 1.321-.592 2-.84.911-.333 1.8-.723 2.737-.99a3.791 3.791 0 0 0 .415-.157c.2-.079.393-.166.594-.238.232-.084.471-.151.7-.235.634-.229 1.257-.492 1.9-.688.835-.255 1.631-.615 2.462-.878a1.066 1.066 0 0 0 .182-.106 5.618 5.618 0 0 0-.354-1.08c-.148-.344-.286-.691-.429-1.04a1.722 1.722 0 0 0-.6.13c-.468.156-.925.34-1.386.515-1.046.4-2.109.747-3.163 1.12a7.445 7.445 0 0 0-1.29.49.955.955 0 0 1-.186.065c-.454.149-.908.3-1.362.447-.14.047-.279.1-.417.154-.214.084-.422.184-.639.258-.53.18-1.065.348-1.6.522-.17.056-.354.094-.429.283a12.556 12.556 0 0 0 .732 2.31zm8.153-2.473a.824.824 0 0 0-.531.114 4.942 4.942 0 0 1-.918.356c-.4.138-.813.266-1.215.41-.324.116-.64.255-.963.374-.262.1-.531.176-.8.267-.09.031-.175.074-.271.116a.95.95 0 0 0 .013.213q.408 1.294.824 2.585a1.887 1.887 0 0 0 .119.238 3.632 3.632 0 0 0 .434-.122 24.15 24.15 0 0 1 1.894-.7.7.7 0 0 0 .139-.051 8.458 8.458 0 0 1 1.331-.515c.138-.051.269-.121.4-.183l.373-.177a4.35 4.35 0 0 1-.208-.687 9.638 9.638 0 0 0-.391-1.476c-.063-.251-.149-.5-.231-.762zm3.089-1.139a8.8 8.8 0 0 0-1.292.455c-.4.216-.884.239-1.279.491a15.84 15.84 0 0 0 .755 2.779.786.786 0 0 0 .113.172 21.434 21.434 0 0 0 2.828-1l-.422-1.281-.386-1.174a.634.634 0 0 0-.318-.438zm-10.122 7a.744.744 0 0 0 .2 0q1.184-.425 2.365-.854a1.34 1.34 0 0 0 .177-.1 1.036 1.036 0 0 0-.02-.2q-.422-1.342-.852-2.683c-.014-.042-.058-.075-.1-.124a2.092 2.092 0 0 0-.749.218 21.515 21.515 0 0 0-1.989.868 1.685 1.685 0 0 0 .169.573 6.326 6.326 0 0 1 .241.592c.136.406.258.816.388 1.224.05.157.107.31.17.486",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3584",
    d: "M203.875 246.726c-.066-.161.12-.257.19-.3a2.173 2.173 0 0 1 .484-.231c.953-.312 1.919-.587 2.86-.93s1.9-.627 2.834-1c.688-.274 1.394-.487 2.089-.736a1.161 1.161 0 0 1 .332-.086.82.82 0 0 1 .252.068.32.32 0 0 1-.164.4 1.6 1.6 0 0 1-.321.124c-.531.174-1.076.315-1.59.528s-1.041.4-1.57.578c-.281.093-.565.176-.844.275q-1.926.688-3.878 1.3a1.6 1.6 0 0 1-.331.093c-.087 0-.278.074-.343-.083",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3585",
    d: "M643.327 242.978a38.682 38.682 0 1 1-38.682 38.682 38.683 38.683 0 0 1 38.682-38.682",
    style: {
      fill: "#0099d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3586",
    d: "M634.394 254.983a2.778 2.778 0 0 1 .869 1.348 8.756 8.756 0 0 1 .542 2.323c-.268.471-.616.39-1.019.2-.5-.963-.75-2.028-1.138-2.949a1.331 1.331 0 0 1 .366-.851z",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3587",
    d: "M635.417 266.025a5.771 5.771 0 0 1 1.641-.726c.7-.222 1.4-.436 2.263-.7.123 0 .322.153.422.411a10 10 0 0 1 .443 1.271c.4 1.656 1 3.25 1.538 4.862.6 1.794 1.238 3.576 1.857 5.364.63 1.818 1.248 3.641 1.891 5.454 1.03 2.9 2.089 5.793 3.112 8.7.5 1.422.926 2.87 1.421 4.293a385.68 385.68 0 0 0 2.082 5.8 303.524 303.524 0 0 0 1.772 4.68.8.8 0 0 1-.084.813 11.509 11.509 0 0 1-4.078 1.215c-.151-.348-.286-.664-.424-.979-.619-1.41-1.264-2.81-1.854-4.232q-1.088-2.622-2.1-5.274-1.227-3.187-2.4-6.4c-.508-1.385-.973-2.785-1.464-4.176-.577-1.633-1.171-3.26-1.74-4.9-.505-1.454-.988-2.916-1.475-4.376q-.473-1.414-.926-2.835c-.245-.763-.5-1.523-.717-2.294-.437-1.577-.849-3.16-1.27-4.741a1.4 1.4 0 0 1 .09-1.23",
    style: {
      fill: "#f6d8ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3588",
    d: "M635.268 258.024a1.277 1.277 0 0 1 .907.563 6.584 6.584 0 0 1 .625.852c.934 1.606 1.855 3.221 2.776 4.835a1.14 1.14 0 0 1 .128 1.19c-.323.148-.718.348-1.128.514-.771.312-1.552.6-2.325.908a1.1 1.1 0 0 1-.91.1.877.877 0 0 1-.347-.668 15.8 15.8 0 0 1-.2-2.773c-.049-1.148-.081-2.3-.106-3.446a8.852 8.852 0 0 1 .048-1.151 1.072 1.072 0 0 1 .532-.924",
    style: {
      fill: "#f6bd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3589",
    d: "M640.691 268.06q-.133-.428-.257-.858c-.568.175-1.136.346-1.7.544-.932.331-1.852.694-2.777 1.043a7.396 7.396 0 0 0-.207.081l.226.852q2.18-.759 4.355-1.525c.125-.042.243-.089.36-.137",
    style: {
      fill: "#212223"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 599",
    transform: "translate(686.523 124.053)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h100.516v3.868H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 600",
    transform: "translate(686.523 137.592)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h122.447v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 601",
    transform: "translate(686.523 150.486)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h116.963v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 602",
    transform: "translate(686.523 163.381)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h96.86v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 603",
    transform: "translate(686.523 176.275)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h122.447v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 604",
    transform: "translate(686.523 189.168)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h111.481v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 605",
    transform: "translate(686.523 202.063)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h122.447v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 606",
    transform: "translate(129.281 300.299)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h70.919v3.868H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 607",
    transform: "translate(129.281 313.838)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h125.864v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 608",
    transform: "translate(129.281 326.732)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h121.996v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 609",
    transform: "translate(129.281 339.627)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h107.813v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 610",
    transform: "translate(129.281 352.52)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h125.864v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 611",
    transform: "translate(129.281 365.414)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h118.128v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 612",
    transform: "translate(129.281 378.309)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h125.864v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 613",
    transform: "translate(129.281 391.632)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h107.813v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 614",
    transform: "translate(129.281 404.527)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h125.864v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 615",
    transform: "translate(129.281 417.421)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h118.128v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 616",
    transform: "translate(129.281 430.315)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h125.864v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 617",
    transform: "translate(0 143.33)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h120.522v3.868H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 618",
    transform: "translate(0 156.869)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h146.817v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 619",
    transform: "translate(0 169.763)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h140.242v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 620",
    transform: "translate(0 182.658)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h116.138v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 621",
    transform: "translate(0 195.551)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h146.817v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 622",
    transform: "translate(0 208.445)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h133.669v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 623",
    transform: "translate(0 221.34)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h146.817v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 624",
    transform: "translate(600.133 366.596)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h70.918v3.868H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 625",
    transform: "translate(600.133 380.135)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h86.391v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 626",
    transform: "translate(600.133 393.029)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h82.522v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 627",
    transform: "translate(600.133 405.924)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h68.339v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 628",
    transform: "translate(600.133 418.817)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h86.391v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 629",
    transform: "translate(600.133 431.711)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h78.654v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 630",
    transform: "translate(600.133 444.606)",
    style: {
      fill: "#332178"
    },
    d: "M0 0h86.391v2.578H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3590",
    d: "M605.326 47.673A47.674 47.674 0 1 1 653 95.348a47.674 47.674 0 0 1-47.675-47.675z",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3591",
    d: "M672.7 57.234a.736.736 0 0 1 .575-.015c.364.083.726.174 1.087.266a2.214 2.214 0 0 1 1.062.678 1.331 1.331 0 0 1 .124.173 2.232 2.232 0 0 1 .2 1.549 1.4 1.4 0 0 1-.6 1.026 1.96 1.96 0 0 1-.511.276 2.843 2.843 0 0 1-1.255.178c-.369-.044-.741-.057-1.111-.089a.579.579 0 0 1-.311-1.026.585.585 0 0 1 .5-.139c.212.02.424.04.637.04a1.279 1.279 0 0 0 .909-.384.573.573 0 0 0 .1-.8.566.566 0 0 0-.17-.145 3.745 3.745 0 0 0-.425-.213c-.277-.115-.558-.219-.8-.315-.265-.389-.1-.718-.006-1.055",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3592",
    d: "m629.23 47.265.271.4c-.024.152-.035.293-.071.429-.113.426-.393.469-.736.406a2.844 2.844 0 0 1-.346-.134 1.434 1.434 0 0 0-1.13.07.844.844 0 0 0 .161 1.184.816.816 0 0 0 .138.086 2.385 2.385 0 0 0 .755.38.527.527 0 0 1 .36.273 3.258 3.258 0 0 1-.068.908.455.455 0 0 1-.5.4.419.419 0 0 1-.087-.018 3.6 3.6 0 0 1-2.05-.92 2 2 0 0 1-.488-2.423 1.729 1.729 0 0 1 .289-.375 2.388 2.388 0 0 1 2.1-.932 6.168 6.168 0 0 1 1.4.256",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3593",
    d: "M642.535 44.854a.58.58 0 0 1 .5-.257 3.906 3.906 0 0 1 1.522.18.531.531 0 0 1 .4.509 1.945 1.945 0 0 1-.021.528q-.243 1.091-.517 2.175a.518.518 0 0 1-.563.467.564.564 0 0 1-.107-.022 14.452 14.452 0 0 1-1.449-.334.516.516 0 0 1-.38-.621 2.223 2.223 0 0 1 .065-.312 13.188 13.188 0 0 1 .488-1.8 1.993 1.993 0 0 0 .065-.516",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3594",
    d: "M638.469 46.94a2.855 2.855 0 0 1-.557-.107 14.351 14.351 0 0 0-2.2-.621c-.742-.183-1.488-.34-2.234-.5a1.253 1.253 0 0 1-.838-.548 1.5 1.5 0 0 1 .134-1.067 2.222 2.222 0 0 0 .128-.292.825.825 0 0 1 1.005-.584c.93.149 1.854.334 2.778.515.33.065.65.176.98.241a3.674 3.674 0 0 1 .91.291 2.445 2.445 0 0 1 .318.192.557.557 0 0 1 .249.554 4.189 4.189 0 0 1-.118.628q-.139.486-.321.958a1.848 1.848 0 0 1-.234.34",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3595",
    d: "M673.875 58.6c.2-.052.39-.1.579-.146.6-.137 1.221-.239 1.815-.414a6.753 6.753 0 0 0 2.6-1.42 18.785 18.785 0 0 0 1.972-2.017 7.975 7.975 0 0 0 1.164-1.963c.078-.179.145-.362.231-.537a.488.488 0 0 1 .632-.278.472.472 0 0 1 .161.1.782.782 0 0 1 .3.755 4.626 4.626 0 0 1-.338 1.116 13.721 13.721 0 0 1-2.275 3.263 4.025 4.025 0 0 0-.21.241 5.671 5.671 0 0 1-2.121 1.565 21.088 21.088 0 0 1-2.447.9 3.134 3.134 0 0 1-1.938-.011c-.408-.126-.52-.383-.335-.78a3.647 3.647 0 0 1 .211-.376",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3596",
    d: "M621.575 42.163a.949.949 0 0 1 .934-.145.568.568 0 0 1 .422.437 4.787 4.787 0 0 1 .064.686c.02.46.023.921.047 1.381a3.884 3.884 0 0 0 .476 1.513 2.531 2.531 0 0 0 .97 1.037c.271.167.559.305.842.453.267.14.542.266.8.413a2.169 2.169 0 0 0 .861.255c.418.041.57.158.592.458a.685.685 0 0 1-.555.735 1.984 1.984 0 0 1-.634.019 5.549 5.549 0 0 1-2.1-.717c-.12-.075-.249-.135-.374-.2a3.238 3.238 0 0 1-.911-.726 6.206 6.206 0 0 1-1.513-2.833 6.808 6.808 0 0 1-.027-2.382 3.03 3.03 0 0 1 .106-.384",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3597",
    d: "M673.951 52.248a10.882 10.882 0 0 1-.141 1.71c-.147.821-.259 1.648-.4 2.47-.076.438-.19.868-.28 1.3-.222 1.079-.427 2.161-.662 3.237-.371 1.7-.786 3.4-1.133 5.1-.2.975-.38 1.953-.614 2.92-.155.639-.3 1.282-.462 1.918-.2.756-.386 1.517-.635 2.257-.176.523-.283 1.067-.475 1.58-.231.62-.351 1.266-.53 1.9-.126.444-.283.879-.429 1.317a.632.632 0 0 1-.32.39 2.621 2.621 0 0 1-.331-.027c-.244-.049-.485-.112-.727-.171-.933-.226-1.867-.447-2.8-.683-.481-.122-.956-.272-1.433-.41l-.051-.014c-1.374-.363-2.742-.75-4.123-1.085-2.4-.582-4.813-1.125-7.216-1.7-.794-.189-1.577-.425-2.367-.635-.378-.1-.76-.186-1.137-.288-.428-.116-.852-.247-1.279-.368-.154-.044-.31-.08-.466-.117l-8.986-2.1c-.571-.133-1.139-.281-1.713-.4-2.571-.554-5.152-1.063-7.711-1.673-.6-.144-1.218-.242-1.829-.354a3.584 3.584 0 0 1-1.084-.391 1.215 1.215 0 0 1-.079-.325 8.776 8.776 0 0 1 .056-1.063c.094-.686.222-1.366.327-2.051.281-1.847.788-3.647 1.143-5.478.163-.838.3-1.681.534-2.5.293-1.042.537-2.1.893-3.123.093-.268.141-.551.218-.824q.34-1.2.69-2.407.237-.817.486-1.633c.275-.9.544-1.8.839-2.694a10.819 10.819 0 0 1 .443-1.034.8.8 0 0 1 .71-.081c.571.134 1.142.27 1.714.4.9.2 1.8.437 2.71.59 1.544.259 3.063.631 4.587.978.832.189 1.67.365 2.485.614 1.447.442 2.928.743 4.391 1.118.2.052.414.084.631.128a2.173 2.173 0 0 0 .271-.271c.3-.44.606-.877.881-1.333a.856.856 0 0 1 .772-.47 7.345 7.345 0 0 1 1.479.154c.507.092 1.006.227 1.514.317 2.873.508 5.686 1.285 8.538 1.885.418.088.831.193 1.247.288a5.407 5.407 0 0 0 1.1.193 2.116 2.116 0 0 1 .418.081c1.109.257 2.218.51 3.325.774.6.144 1.207.287 1.8.484.656.218 1.343.342 2.015.513.223.057.442.132.663.2a1.866 1.866 0 0 0 .358.1 11.826 11.826 0 0 1 1.748.458.5.5 0 0 1 .427.329",
    style: {
      fill: "#222"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3598",
    d: "M622.88 42.64a1.741 1.741 0 0 1-1.556-.335 1.509 1.509 0 0 1-.02-.84c.158-.675.293-1.357.483-2.023a11.9 11.9 0 0 1 1.552-3.2 7.551 7.551 0 0 1 3.4-2.739 41.324 41.324 0 0 1 5.307-1.93 34.177 34.177 0 0 1 4.786-1.047 37.63 37.63 0 0 0 3.826-.691 14.509 14.509 0 0 0 2.934-1.107 13.658 13.658 0 0 0 2.865-2.022 16.017 16.017 0 0 0 2.666-3.034 27.874 27.874 0 0 1 3.011-3.728 10.694 10.694 0 0 1 3.784-2.529 6.68 6.68 0 0 1 2.718-.415 12.336 12.336 0 0 1 3.092.517 7.474 7.474 0 0 1 2.359 1.208 12.276 12.276 0 0 1 2.5 2.456 7.882 7.882 0 0 1 1.272 2.5c.361 1.246.768 2.478 1.166 3.712a13.974 13.974 0 0 0 .944 2.145 10.351 10.351 0 0 0 2.768 3.273 36.608 36.608 0 0 0 3.078 2.2 18.835 18.835 0 0 1 2.855 2.223 3.293 3.293 0 0 0 .317.285 34.1 34.1 0 0 1 2.558 2.413 14.758 14.758 0 0 1 1.2 1.361 10.343 10.343 0 0 1 1.829 3.7 5.325 5.325 0 0 1 .163 1.158 14.808 14.808 0 0 1-.083 2.446 17.666 17.666 0 0 1-.509 2.668c-.116.409-.253.813-.381 1.22a.758.758 0 0 1-.3.447c-.428.067-.733-.307-1.1-.339a.754.754 0 0 1-.34-.717c.011-.6.012-1.209.066-1.809a17.857 17.857 0 0 0 .049-2.765 5.7 5.7 0 0 0-.128-.842 13.785 13.785 0 0 0-1.129-3.1 5.215 5.215 0 0 0-.627-.923 15.573 15.573 0 0 0-3.035-2.823c-.916-.673-1.827-1.352-2.744-2.024-.3-.22-.607-.435-.921-.635a16.112 16.112 0 0 1-1.822-1.386c-.728-.624-1.464-1.24-2.188-1.869a13.229 13.229 0 0 1-2.455-2.863 6.931 6.931 0 0 1-.865-2c-.082-.309-.155-.621-.235-.93a14.05 14.05 0 0 0-1.093-2.886 4.625 4.625 0 0 0-.425-.674 26.31 26.31 0 0 0-.834-1.039 6.687 6.687 0 0 0-2.314-1.672 6.145 6.145 0 0 0-3.6-.423 8.2 8.2 0 0 0-4.153 1.922.9.9 0 0 0-.079.071 17.632 17.632 0 0 0-3.014 3.847 17.191 17.191 0 0 1-1.617 2.377q-.73.949-1.519 1.855a8.214 8.214 0 0 1-2 1.668c-.152.091-.3.184-.452.283a8.438 8.438 0 0 1-2.066.975 21.8 21.8 0 0 1-2.548.775c-1.27.259-2.539.535-3.819.731-.963.147-1.943.185-2.916.26a19.265 19.265 0 0 0-2.9.38 11.127 11.127 0 0 0-3.578 1.478c-.328.213-.664.414-1 .615a3.2 3.2 0 0 0-.737.61c-.357.4-.7.8-1.063 1.2a4.714 4.714 0 0 0-1.016 1.733 1.642 1.642 0 0 1-.367.655",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3599",
    d: "m630.863 49.017 2.951.735 6.035 1.5c3.977.99 7.945 2.042 11.937 2.972 6.738 1.569 13.287 3.861 20.021 5.456a3.224 3.224 0 0 1 .864.29c.153-.746.3-1.493.455-2.24.089-.435.2-.866.28-1.3.143-.822.254-1.649.4-2.47a10.882 10.882 0 0 0 .141-1.71.505.505 0 0 0-.422-.333 11.827 11.827 0 0 0-1.748-.458 1.867 1.867 0 0 1-.358-.1c-.221-.066-.44-.141-.663-.2-.672-.171-1.359-.3-2.015-.513-.593-.2-1.2-.339-1.8-.484-1.107-.264-2.216-.518-3.325-.774a2.115 2.115 0 0 0-.418-.08 5.338 5.338 0 0 1-1.1-.193c-.416-.1-.83-.2-1.247-.288-2.852-.6-5.666-1.377-8.538-1.885-.507-.089-1.007-.225-1.514-.317a7.353 7.353 0 0 0-1.479-.154.856.856 0 0 0-.772.47c-.275.456-.58.894-.881 1.333a2.164 2.164 0 0 1-.271.271c-.218-.044-.427-.075-.631-.128-1.463-.375-2.944-.676-4.391-1.118-.815-.249-1.653-.425-2.485-.614-1.524-.347-3.043-.719-4.587-.978-.911-.153-1.807-.387-2.71-.59-.572-.129-1.143-.265-1.714-.4a.8.8 0 0 0-.71.081c-.138.318-.322.666-.443 1.034-.288.87-.55 1.748-.818 2.624a8.752 8.752 0 0 0 1.956.561",
    style: {
      fill: "#fdeee5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3600",
    d: "M638.321 54.792c-.324-.133-.659-.251-.975-.406a1.388 1.388 0 0 1-.637-.822 2.6 2.6 0 0 1-.041-1.871 1.662 1.662 0 0 1 .319-.543 2.908 2.908 0 0 1 2.222-.978 1.893 1.893 0 0 1 1.783 1.128 3.373 3.373 0 0 1 .311 1.548 1.736 1.736 0 0 1-.771 1.391 3.122 3.122 0 0 1-1.517.6 3.75 3.75 0 0 1-.694-.047",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3601",
    d: "M645.809 50.429a4.813 4.813 0 0 1-1.364-.268c-.151-.051-.3-.1-.458-.138-.324-.092-.647-.188-.973-.269q-.955-.239-1.914-.461a11.657 11.657 0 0 1-1.657-.4 1.558 1.558 0 0 0-.471-.054 1.521 1.521 0 0 1-.612-.1c-.032-.231 0-.331.142-.33a2.951 2.951 0 0 1 1.107.075 7.532 7.532 0 0 0 1.238.312c.313.067.634.1.943.175.688.172 1.37.362 2.055.545l1.644.44c.119.032.24.059.338.084.128.13.112.237-.018.389",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3602",
    d: "M667.893 65.239a.948.948 0 0 1-1.076.8.93.93 0 0 1-.363-.132.375.375 0 0 1-.126-.094 1.281 1.281 0 0 1-.343-1.071.906.906 0 0 1 .8-.8.888.888 0 0 1 .941.45.994.994 0 0 1 .167.845",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3603",
    d: "M629.618 58.343a.2.2 0 0 1 .134-.249h.01a.21.21 0 0 1 .056-.007 1.007 1.007 0 0 1 .314.034c1.507.343 3.016.68 4.519 1.037.482.114.953.277 1.423.435.079.027.127.144.176.2a.276.276 0 0 1-.3.226.826.826 0 0 1-.21-.03c-.581-.163-1.161-.329-1.741-.493-.256-.072-.512-.15-.771-.21q-1.142-.266-2.287-.519c-.172-.038-.352-.042-.528-.063a1.086 1.086 0 0 1-.8-.358",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3604",
    d: "m629.951 56.461.067-.321a1.315 1.315 0 0 1 .845.123 9.753 9.753 0 0 0 1.333.36c.346.078.7.138 1.043.214a10.355 10.355 0 0 1 1.385.369 9.626 9.626 0 0 0 1.085.262c.117.028.232.068.376.11 0 .114 0 .211-.007.292a.67.67 0 0 1-.634.086c-.6-.161-1.2-.33-1.792-.5-.2-.057-.4-.128-.612-.175-.4-.091-.8-.171-1.2-.252a12.71 12.71 0 0 1-1.889-.568",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3605",
    d: "M631.4 46.959c-.053-.152 0-.238.113-.278a.4.4 0 0 1 .208-.017 10.465 10.465 0 0 1 1.293.317 9.521 9.521 0 0 0 1.071.315c.552.131 1.1.258 1.637.382.084.253.033.377-.137.374a2.05 2.05 0 0 1-.42-.056c-.606-.139-1.22-.257-1.814-.437-.611-.185-1.217-.386-1.841-.525-.032-.008-.059-.039-.11-.075",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3606",
    d: "M666.672 57.489c-.4-.093-.8-.176-1.193-.281-.377-.1-.747-.224-1.121-.331-.256-.073-.516-.131-.772-.2-.289-.083-.575-.179-.865-.263a3.706 3.706 0 0 0-.36-.074c-.261-.049-.529-.076-.783-.15a1.718 1.718 0 0 1-.519-.259.65.65 0 0 1-.28-.6 14.605 14.605 0 0 1 .48-2.937c.1-.341.22-.674.342-1.007a2 2 0 0 1 .2-.377.658.658 0 0 1 .572-.334 2.759 2.759 0 0 1 .581.035c.987.223 2 .306 2.975.589a9.085 9.085 0 0 1 1.275.373 3.85 3.85 0 0 0 .669.174 7.135 7.135 0 0 1 1.221.371 5.258 5.258 0 0 0 .719.193 1.909 1.909 0 0 1 .446.164.759.759 0 0 1 .4.85c-.18.977-.332 1.959-.572 2.924a5.629 5.629 0 0 1-.458 1.131.866.866 0 0 1-.877.483 1.9 1.9 0 0 1-.367-.061l-1.713-.4z",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3607",
    d: "M663.027 51.972a1.52 1.52 0 0 1 .883-.05c1.267.276 2.536.547 3.8.849a7.894 7.894 0 0 1 1.09.417.722.722 0 0 1 .469.855c-.061.385-.155.766-.253 1.143-.076.291-.182.573-.272.86-.027.085-.039.174-.068.258a.672.672 0 0 1-.776.546.291.291 0 0 1-.076-.018 16.041 16.041 0 0 1-2.376-.587 3.445 3.445 0 0 0-.566-.15 7.687 7.687 0 0 1-1.61-.542c-.211-.092-.428-.171-.638-.265a.772.772 0 0 1-.5-.854 5.329 5.329 0 0 1 .137-.731c.074-.291.188-.573.256-.865a1.516 1.516 0 0 1 .5-.866",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3608",
    d: "M684.551 49.307h-.019a7.3 7.3 0 0 0-.9.013q-.754.083-1.507.175a25.49 25.49 0 0 1-.037.5 17.548 17.548 0 0 1 2.388-.23c.025-.152.052-.3.075-.458",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3609",
    d: "m684.138 51.269.03-.119c-.713-.043-1.427-.062-2.141-.043 0 .169-.007.337-.01.506.67-.027 1.34-.025 2.01.015.038-.119.077-.239.111-.359",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3610",
    d: "M684.258 44.03c-.056-.151-.116-.3-.178-.448-.86.34-1.723.673-2.574 1.034l-.069.031c.061.157.12.314.176.473q.53-.231 1.069-.44c.532-.207 1.052-.43 1.576-.65",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3611",
    d: "M679.1 37.617c-.04-.033-.077-.068-.117-.1a4.979 4.979 0 0 1-.243-.218c-.65.671-1.3 1.347-1.965 2l.413.3c.545-.553 1.091-1.106 1.627-1.668.1-.1.192-.207.285-.314",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3612",
    d: "M672.734 32.817c-.041-.033-.08-.068-.121-.1-.673.63-1.3 1.3-1.912 1.992l.391.333c.627-.681 1.215-1.4 1.9-2.021a4.707 4.707 0 0 0-.258-.2",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3613",
    d: "m682.811 41.391-.346.166c-.7.333-1.382.711-2.056 1.1.1.133.2.27.289.41a33.756 33.756 0 0 1 2.4-1.27 6.753 6.753 0 0 0-.287-.406",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3614",
    d: "M681.079 39.467q-1.135.737-2.3 1.428.184.168.365.343 1.139-.712 2.274-1.428z",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3615",
    d: "M675.258 34.645a49.078 49.078 0 0 1-.41-.276q-1.052 1.01-2.043 2.077c.14.1.282.206.427.3.236-.256.472-.511.712-.763.435-.453.876-.9 1.314-1.343",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3616",
    d: "M677.018 35.851c-.082.08-.166.157-.245.24q-.9.94-1.793 1.883l.428.315q1.009-1.063 2.015-2.13c-.133-.1-.269-.207-.4-.308",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3617",
    d: "M684.743 46.977v-.51c-.434.125-.866.254-1.3.362s-.882.208-1.325.307c.006.056.016.113.019.169.008.116.01.232.015.348.6-.143 1.192-.286 1.785-.439.272-.07.541-.152.811-.237",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3618",
    d: "M632.533 31.443c.013.068.026.135.044.2.254.9.5 1.811.778 2.71.166.54.354 1.074.544 1.606l.527-.037a58.119 58.119 0 0 1-1.435-4.606c-.153.04-.305.084-.458.127",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3619",
    d: "M670.768 30.809c-.1-.13-.193-.263-.284-.4l-.1.09a26.851 26.851 0 0 0-1.974 2.1c.113.127.229.251.348.374.031-.035.063-.068.093-.1a22.812 22.812 0 0 1 1.917-2.064",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3620",
    d: "M647.574 25.617c-.111.121-.225.239-.34.356l.042.071c.4.71.792 1.428 1.192 2.139.157.278.318.555.495.821a1.411 1.411 0 0 0 .114.142c.109-.143.216-.286.323-.43-.372-.639-.74-1.281-1.117-1.918-.235-.4-.469-.788-.709-1.181",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3621",
    d: "M646.6 29.206c-.2-.334-.4-.669-.592-1.007-.144-.253-.28-.511-.42-.766q-.191.151-.385.3c.246.458.492.915.75 1.366q.5.874 1.035 1.731a2.281 2.281 0 0 0 .375.439l.3-.36c-.144-.24-.32-.46-.46-.7-.2-.341-.4-.669-.6-1",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3622",
    d: "M626.127 38.281a.806.806 0 0 0 .133-.062c.027-.018.041-.055.073-.1a.523.523 0 0 0-.223-.382l-.641-.562-1.707-1.5c-.1.127-.2.261-.3.4a25.732 25.732 0 0 0 2.6 2.2c.013.009.035 0 .065.006",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3623",
    d: "M625 34.5q.579.7 1.17 1.389.705.817 1.423 1.626c.154-.087.31-.17.468-.247-.91-.995-1.8-2-2.647-3.054a8.448 8.448 0 0 0-.414.286",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3624",
    d: "M629.664 36.084c-.64-.915-1.287-1.826-1.928-2.74l-.138-.2-.462.2c.047.071.094.143.142.213.486.7.978 1.393 1.467 2.089.2.29.4.583.612.87a1.111 1.111 0 0 0 .159.17 11.9 11.9 0 0 1 .379-.118.153.153 0 0 0 0-.06 1.8 1.8 0 0 0-.231-.424",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3625",
    d: "M650.069 24.373c-.192-.4-.375-.808-.58-1.226-.109.152-.217.305-.322.459.342.746.682 1.494 1.034 2.235.145.3.3.607.448.909q.15-.26.313-.51l-.045-.089c-.292-.589-.564-1.186-.848-1.778",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3626",
    d: "M639.4 33.806c-.279-1.134-.552-2.27-.829-3.4l-.033-.134-.472.077c.006.03.01.061.017.091q.466 1.99.941 3.979a4.3 4.3 0 0 0 .128.46 1.107 1.107 0 0 0 .163.317l.413-.085a2.575 2.575 0 0 0-.051-.276c-.089-.347-.192-.686-.277-1.029",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3627",
    d: "M636 30.665c-.16.027-.321.052-.481.082.265 1.329.527 2.66.811 3.985a8.15 8.15 0 0 0 .294.966c.171-.027.342-.056.513-.086-.08-.232-.163-.464-.223-.7a58.357 58.357 0 0 1-.914-4.247",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3628",
    d: "M640.81 29.79c-.053.014-.1.031-.157.045-.111.028-.222.05-.333.075.28.967.559 1.935.849 2.9.178.594.374 1.183.573 1.771q.242-.08.483-.162c-.383-1.109-.7-2.239-1.032-3.364q-.187-.629-.383-1.265",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3629",
    d: "M630.416 32.088c-.154.052-.307.1-.46.158a37.5 37.5 0 0 0 1.722 3.8l.068.122c.188-.026.377-.051.565-.071a6.394 6.394 0 0 1-.279-.5 39.618 39.618 0 0 1-1.616-3.509",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3630",
    d: "M642.76 29.117q.931 2.145 1.873 4.286c.085-.051.171-.1.253-.155.064-.043.131-.082.2-.123q-.941-2.1-1.88-4.209c-.151.069-.3.137-.446.2",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3631",
    d: "m666.557 21.228.034-.038c-.1-.132-.192-.254-.289-.373-.113.116-.216.223-.314.333q-1.075 1.2-2.225 2.332c.1.127.21.255.313.383q.73-.738 1.451-1.485c.356-.371.689-.766 1.03-1.152",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3632",
    d: "M663.982 18.653a7.894 7.894 0 0 0-.389-.268c-.548.915-1.1 1.828-1.637 2.749a16.5 16.5 0 0 0-.36.654q.235.121.462.253.832-1.48 1.672-2.959c.082-.144.167-.286.252-.429",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3633",
    d: "m667.676 23.147-.019.017c-.722.63-1.443 1.262-2.154 1.9-.14.126-.277.256-.415.384.075.16.148.321.217.484q1.245-1.172 2.54-2.288a9.803 9.803 0 0 0-.169-.5",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3634",
    d: "M669.768 29.154c-.074-.148-.146-.3-.217-.447-.17.139-.34.278-.511.415a67.357 67.357 0 0 0-2 1.659c.012.02.023.041.036.061.082.127.166.252.251.377.167-.15.333-.3.5-.447.641-.549 1.3-1.079 1.941-1.618",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3635",
    d: "m668.837 26.824-.154-.477a2.075 2.075 0 0 0-.134.089c-.3.22-.592.454-.883.687l-1.57 1.258c.038.155.077.31.117.464l.019.064 2.118-1.709c.161-.129.32-.259.487-.379",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3636",
    d: "M659.771 19.652c.2-.819.4-1.641.592-2.462a12.269 12.269 0 0 0-.467-.076c-.082.3-.169.6-.251.908-.282 1.03-.52 2.072-.768 3.112.163 0 .325 0 .487.013.007-.038.014-.076.024-.113.117-.462.268-.917.383-1.382",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3637",
    d: "M651.651 20.452q-.187.2-.372.414a68.134 68.134 0 0 0 1.156 3.086c.035.088.077.174.116.261.129-.143.259-.284.39-.425a33.585 33.585 0 0 1-.477-1.167c-.275-.722-.561-1.439-.813-2.169",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3638",
    d: "M654.192 18.284c-.158.1-.313.2-.466.308.081.713.164 1.426.262 2.137.085.621.215 1.235.334 1.852.153-.1.309-.2.466-.3-.191-.9-.32-1.816-.439-2.731-.055-.422-.106-.844-.157-1.266",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3639",
    d: "M622.015 38.758c.228.18.455.361.678.547.464.388.937.763 1.426 1.117.044-.053.089-.106.136-.157.068-.075.134-.151.2-.226a66.328 66.328 0 0 1-2.254-1.742q-.094.225-.186.461",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3640",
    d: "M657.045 17.1c-.166.03-.331.065-.5.108-.031.371-.059.743-.086 1.115q-.111 1.625-.207 3.251c.173-.061.348-.116.527-.165a67.08 67.08 0 0 1 .1-1.674c.061-.878.076-1.759.166-2.635",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3641",
    d: "M666.091 74.5c-.487-.1-.967-.236-1.455-.334-.768-.155-1.5-.442-2.256-.624-2.139-.514-4.275-.989-6.415-1.531q-3.362-.851-6.728-1.678-6.734-1.654-13.491-3.211l-1.785-.408c-.5-.114-1.009-.153-1.5-.268q-3.788-.872-7.573-1.748c-.1.616-.21 1.229-.294 1.847a8.776 8.776 0 0 0-.056 1.063 1.223 1.223 0 0 0 .075.327 3.547 3.547 0 0 0 1.083.393c.611.112 1.226.211 1.829.355 2.559.61 5.14 1.119 7.711 1.673.573.124 1.141.272 1.713.4l8.986 2.1c.156.036.312.073.466.117.427.121.851.251 1.279.368.377.1.759.188 1.137.288.789.21 1.573.445 2.367.635 2.4.573 4.815 1.117 7.216 1.7 1.381.335 2.749.722 4.123 1.085l.051.014c.478.137.952.287 1.433.409.93.236 1.864.457 2.8.683.242.059.483.121.727.171a2.624 2.624 0 0 0 .331.027.632.632 0 0 0 .32-.39c.146-.438.3-.873.429-1.317.115-.4.207-.815.318-1.22-.036-.016-.068-.032-.108-.048a17.118 17.118 0 0 0-2.733-.876",
    style: {
      fill: "#fdeee5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3642",
    d: "M652.8 49.137a4.337 4.337 0 0 0 1.172.354c.571.133 1.145.258 1.714.4.24.06.471.157.707.231a5.546 5.546 0 0 0 .563.16 5.029 5.029 0 0 1 1.053.371.623.623 0 0 1 .42.769 3.6 3.6 0 0 1-.6 1.469.681.681 0 0 1-.647.3.233.233 0 0 1-.053-.006c-.829-.2-1.662-.385-2.485-.607-.6-.162-1.184-.371-1.773-.567a5.5 5.5 0 0 1-.64-.254.515.515 0 0 1-.3-.616 12.285 12.285 0 0 1 .305-1.242 1.224 1.224 0 0 1 .564-.762",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3643",
    d: "M658.251 50.794c-.326.25-.653.5-.969.76a89.19 89.19 0 0 0-1.532 1.3l.637.152a41.604 41.604 0 0 1 2.063-1.708.559.559 0 0 0-.2-.5",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3644",
    d: "M655.9 50.181a1.286 1.286 0 0 0 .185-.169 4.325 4.325 0 0 0-.4-.125l-.2-.046c-.155.114-.31.229-.461.349-.733.586-1.467 1.172-2.194 1.767l-.026.022.063.023.55.185c.222-.2.445-.4.676-.593.6-.478 1.2-.938 1.8-1.413",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3645",
    d: "M654.251 49.717c.049-.04.1-.082.144-.126l-.416-.1-.216-.048c-.61.549-1.214 1.1-1.819 1.658l-.008.035a.5.5 0 0 0 .184.541l.016-.018a20.908 20.908 0 0 1 2.115-1.942",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3646",
    d: "M657.43 50.417a3.318 3.318 0 0 0-.47-.134c-.037-.007-.073-.019-.11-.028a29.82 29.82 0 0 0-.631.539c-.613.535-1.227 1.068-1.834 1.61l-.077.07c.114.034.228.068.344.1l.278.072c.655-.584 1.315-1.164 1.973-1.745.173-.157.358-.312.527-.484",
    style: {
      fill: "#eb6626"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3647",
    d: "M640.077 61.005a10.213 10.213 0 0 1 2.719-4.87 12.876 12.876 0 0 1 2.364-1.9 8.087 8.087 0 0 1 2.966-1.134 9.9 9.9 0 0 1 2.278-.2 2.36 2.36 0 0 1 .266 0 12.838 12.838 0 0 1 2.2.408c.651.237 1.34.345 1.971.644a12.8 12.8 0 0 1 2.91 1.764 4.273 4.273 0 0 1 .836.963c.438.69.9 1.369 1.27 2.1a9.581 9.581 0 0 1 .693 1.9c.2.771.312 1.567.446 2.354a4.2 4.2 0 0 1 .05.8q-.02.824-.08 1.646a5.862 5.862 0 0 1-.118.682c-.03.157-.075.312-.1.469a8.341 8.341 0 0 1-1.581 3.4 10.806 10.806 0 0 1-2.547 2.556 14.756 14.756 0 0 1-2.932 1.731 7.024 7.024 0 0 1-2.973.485 9.65 9.65 0 0 1-2.524-.344c-.61-.186-1.212-.4-1.816-.6-.235-.079-.476-.146-.7-.245a9.16 9.16 0 0 1-2.64-1.775 8.344 8.344 0 0 1-.959-.921 12.974 12.974 0 0 1-1.258-1.975 9.364 9.364 0 0 1-.864-3.114 19.382 19.382 0 0 1-.077-3.613 9.247 9.247 0 0 1 .2-1.214",
    style: {
      fill: "#b2bd33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3648",
    d: "M649.538 69.942a7.337 7.337 0 0 1-4.005-2.163 5.881 5.881 0 0 1-1.27-2.186 3.308 3.308 0 0 1-.091-1.9 2.429 2.429 0 0 0 .119-.682 4.086 4.086 0 0 1 .724-2.247 6.928 6.928 0 0 1 3.246-2.751 5.311 5.311 0 0 1 2.457-.583 17.931 17.931 0 0 1 1.836.19 4.973 4.973 0 0 1 2.885 1.8 6.194 6.194 0 0 1 1.437 4.36 7.116 7.116 0 0 1-1.046 3.584 5.287 5.287 0 0 1-2.32 2.085 6.567 6.567 0 0 1-2.368.654 4.262 4.262 0 0 1-1.6-.161",
    style: {
      fill: "#fdeee5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3649",
    d: "M649.851 67.994a5.067 5.067 0 0 1-2.762-1.491 4.048 4.048 0 0 1-.876-1.503 2.28 2.28 0 0 1-.062-1.311 1.667 1.667 0 0 0 .082-.47 2.809 2.809 0 0 1 .5-1.549 4.776 4.776 0 0 1 2.238-1.9 3.651 3.651 0 0 1 1.694-.4 12.483 12.483 0 0 1 1.266.131 3.433 3.433 0 0 1 1.989 1.243 4.271 4.271 0 0 1 .991 3.006 4.906 4.906 0 0 1-.721 2.471 3.653 3.653 0 0 1-1.6 1.438 4.516 4.516 0 0 1-1.633.451 2.954 2.954 0 0 1-1.106-.112",
    style: {
      fill: "#402625"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3650",
    d: "M652.89 63.278a2.054 2.054 0 0 1-.191.388.946.946 0 0 1-1.307.29.931.931 0 0 1-.3-.3 2.033 2.033 0 0 1-.165-.272.992.992 0 0 1 .86-1.45 1.8 1.8 0 0 1 .474.033.919.919 0 0 1 .678.9 3.83 3.83 0 0 1-.05.414",
    style: {
      fill: "#fdeee5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3651",
    d: "M649.6 65.584c-.537-.346-.65-.613-.466-1.054a.749.749 0 0 1 .85-.375.818.818 0 0 1 .57.854.7.7 0 0 1-.234.4.919.919 0 0 1-.72.175",
    style: {
      fill: "#fdeee5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.e5541ba48c2170f45be3fde41227ae15.svg";
export { ForwardRef as ReactComponent };